import { createSlice } from "@reduxjs/toolkit";

import { ReduxReducer } from "../../../../interface";
import { Car } from "../../../../../services";
import { Orders } from "../../interface";

import { State } from "./interface";

const initialState: State = {
	cars: [], // subscribe base
};

const setCarsData: ReduxReducer<State, Car.Model[]> = (state, action) => {
	state.cars = action.payload;
};

const orderMapData = createSlice({
	name: Orders.ConstantOrdersSlice.PARKING_DATA,
	initialState,
	reducers: {
		setCarsData,
	},
});

export const orderMapDataAction = orderMapData.actions;
export const orderMapDataReducer = orderMapData.reducer;
export type orderMapDataState = State;

export default orderMapData;
